import { Absence } from '@/modules/working_hours/domain/Absence';
import { AbsenceRepo } from '@/modules/working_hours/domain/AbsenceRepo';

export class UpdateAbsenceCommand {
  repo: any;
  popup: any;

  constructor(AbsenceRepo: any, popup: any) {
    this.repo = AbsenceRepo;
    this.popup = popup;
  }

  async execute(absence: any) {
    const confirmed = await this.popup.show(absence);

    if (!confirmed) return false;

    await this.repo.save(absence);
    this.popup.close();
    return true;
  }
}